


































































































































































































































































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  SimplifyMeter,
  MeterCost,
  User,
  MeterType,
  SubMeterType,
} from "@/api/baseDefine";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
  GetMetersReq,
  updateMeter,
  meterTypes,
  MeterTypeReq,
} from "@/api/meter";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
import { queryUser, QueryUserReq } from "@/api/user";
import { GetMeterCostReq, meterCosts } from "@/api/meterCost";
@Component
export default class MeterEditDialog extends Vue {
  private subMeterTypes: SubMeterType[] = [];
  private mqttTypes = ["normal", "tsl", "aws"];
  private subMeterVisible: boolean = false;
  private connectMeterIDVisible: boolean = false;
  private editMeter: Meter = <Meter>{};
  private dialogEditMeter: boolean = false;
  private queryUsers: User[] = [];
  private queryMeterCosts: MeterCost[] = [];
  private queryInstallUsers: User[] = [];
  private queryMeters: Meter[] = [];
  private loading = false;
  private meterTypes: string[] = [];
  private bRouteMaxReadingVisible = false;
  private queryMeterTypes: MeterType[] = [];
  private clickShow(editMeter: Meter) {
    console.log("MeterEditDialog clickShow");
    if (!editMeter) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.onlyOneMeterSupport").toString(),
        type: "warning",
      });
      return;
    }
    this.editMeter = editMeter;
    this.dialogEditMeter = true;
    if (this.editMeter.meterTypeID == 5) {
      this.bRouteMaxReadingVisible = true;
    } else {
      this.bRouteMaxReadingVisible = false;
    }
    this.onMeterTypeChange();
  }

  public async handleEditMeter() {
    console.log(this.editMeter);
    if (!!this.editMeter.installDate) {
      this.editMeter.installDate = formatDate(
        new Date(this.editMeter.installDate)
      );
    }
    if (!!this.editMeter.expireDate) {
      this.editMeter.expireDate = formatDate(
        new Date(this.editMeter.expireDate)
      );
    }
    const res = await updateMeter(this.editMeter);
    if (res.code === ResCode.SUCCESS) {
      this.dialogEditMeter = false;
      //   this.getList();
    }
  }

  public onSelectParentMeterID(b) {
    if (b) {
      this.queryMeter("");
    }
  }

  public async queryMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meters(<GetMetersReq>{ meter: { meterID: query } });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }

  public onSelectInstallUser(b) {
    if (b) {
      this.queryInstallUser("");
    }
  }

  public async queryInstallUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 1,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryInstallUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public onSelectMeterCost(b) {
    if (b) {
      this.queryMeterCost("");
    }
  }

  public async queryMeterCost(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meterCosts(<GetMeterCostReq>{
        page: 1,
        pageSize: 10,
        name: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeterCosts = res.data.meterCostData.list;
        this.loading = false;
      }
    }
  }

  public onSelectOwnUser(b) {
    if (b) {
      this.queryOwnUser("");
    }
  }

  public async queryOwnUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 0,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public async queryMeterType() {
    this.loading = true;
    const res = await meterTypes(<MeterTypeReq>{});
    if (res.code === ResCode.SUCCESS) {
      this.queryMeterTypes = res.data.meterTypes.list;
      for (let type of this.queryMeterTypes) {
        type.name = this.meterTypes[type.id - 1];
      }
      this.loading = false;
    }
  }

  private async onMeterTypeChange() {
    console.log("onMeterTypeChange", this.editMeter.meterTypeID);

    let subMeterTypeArray = this.$t("subMeterTypeArray");
    let subMeterType: string[] =
      subMeterTypeArray[this.editMeter.meterTypeID - 1];
    this.subMeterTypes = [];
    if (subMeterType.length > 0) {
      for (let i = 0; i < subMeterType.length; i++) {
        this.subMeterTypes.push(<SubMeterType>{
          lable: subMeterType[i],
          index: i,
        });
      }
      this.subMeterVisible = true;
    } else {
      this.subMeterVisible = false;
    }
    if (
      (this.editMeter.meterTypeID == 1 || this.editMeter.meterTypeID == 3) &&
      this.editMeter.subMeterTypeIndex == 2
    ) {
      this.connectMeterIDVisible = true;
    } else {
      this.connectMeterIDVisible = false;
    }
    if (this.editMeter.meterTypeID == 5) {
      this.bRouteMaxReadingVisible = true;
    } else {
      this.bRouteMaxReadingVisible = false;
      if (this.editMeter.routeBMaxReading > 0) {
        this.editMeter.routeBMaxReading = 0;
      }
    }
    // if (!!this.editMeter.meterCostName) {
    //   this.editMeter.meterCostName = "";
    // }
  }
  public onSelectConnectMeterID(b) {
    if (b) {
      this.queryConnectedMeter("");
    }
  }
  public async queryConnectedMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      let req: GetMetersReq = <GetMetersReq>{};
      req.meter = <Meter>{};
      req.meter.meterID = query;
      req.meter.meterTypeID = 2;
      // req.meter.subMeterTypeIndex = 1;
      const res = await meters(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }
  // private async onReadPowerLineValueChange(b) {
  //   console.log(this.editMeter);
  //   if (!!this.editMeter.installDate) {
  //     this.editMeter.installDate = formatDate(
  //       new Date(this.editMeter.installDate)
  //     );
  //   }
  //   if (!!this.editMeter.expireDate) {
  //     this.editMeter.expireDate = formatDate(
  //       new Date(this.editMeter.expireDate)
  //     );
  //   }
  //   const res = await updateMeter(this.editMeter);
  //   if (res.code === ResCode.SUCCESS) {
  //     // this.dialogEditMeter = false;
  //     //   this.getList();
  //   }
  // }

  // private async onReadPowerLineValueFrequenceChange(){

  // }
  private created() {
    this.meterTypes = [
      this.$t("meterTypes.water").toString(),
      this.$t("meterTypes.power").toString(),
      this.$t("meterTypes.gas").toString(),
      this.$t("meterTypes.hot").toString(),
      this.$t("meterTypes.pv").toString(),
    ];
    this.queryMeterType();
  }
}
